import React from "react";
import { useSelector } from "react-redux";

import { useIsClientSide } from "@utils/hooks/isClient.hook";

import * as HeaderModule from "@redux/modules/value/header/header.module";
import * as HeaderSelectors from "@redux/modules/value/header/header.selectors";
import { useThunkDispatch } from "@redux/dispatcher";

import { FlyoutButton } from "./flyoutButton.component";

export type FlyoutButtonContainerProps = {
    title: string;
    size: "small" | "large";
};

const FlyoutButtonContainer = ({ title, size }: FlyoutButtonContainerProps) => {
    const dispatch = useThunkDispatch();
    const header = useSelector(HeaderSelectors.getHeader);
    const isClient = useIsClientSide();

    const handleUpdate = () => {
        dispatch(HeaderModule.update({ flyoutActive: !header?.flyoutActive }));
    };

    return (
        <FlyoutButton
            title={title}
            size={size}
            active={isClient && !!header?.flyoutActive}
            update={handleUpdate}
        />
    );
};

export { FlyoutButtonContainer };
